export const STATES_PLUS_DC = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
  'DC',
] as const;

export const TERRITORIES = ['PR', 'GU', 'MP', 'VI', 'AS'] as const;

export const STATES_AND_TERRITORIES = [...STATES_PLUS_DC, ...TERRITORIES];

export const BETA_STATES: string[] = ['AK', 'CA', 'DE', 'MA', 'TX'];

export const LAUNCHED_STATES: string[] = [
  'AZ',
  'CO',
  'CT',
  'DC',
  'GA',
  'IL',
  'IN',
  'ME',
  'MI',
  'NM',
  'NV',
  'NY',
  'OR',
  'PA',
  'RI',
  'VA',
  'VT',
  'WI',
];

export const US_STATE_NAMES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'Washington, D.C.',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];
